import { __require as n } from "./_coreJsData.js";
var a, i;
function _() {
  if (i) return a;
  i = 1;
  var e = n(), s = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function u(r) {
    return !!s && s in r;
  }
  return a = u, a;
}
export {
  _ as __require
};
